const types = require('../../constants/actionTypes');

const fetchRequested = ({ id, idType }) => ({
    type: types.FUNDS_FETCH_REQUESTED,
    payload: { id, idType },
});

module.exports = fetchRequested;
